import React from 'react'
import './_side-by-side-block.scss'
import { Block } from 'types'
import { ComponentList } from 'components/blocks/component-list/component-list'

interface SideBySideBlockProps {
    blocks?: Block[]
}

export const SideBySideBlock = ({blocks}: SideBySideBlockProps) => {
    return (
        <div className="side-by-side-block">
            {blocks && <ComponentList blocks={blocks} />}
        </div>
    )
}